import { Component, h, Method, Prop } from "@stencil/core";
import { Column } from "../table-interfaces";
import { TableCell } from "../table-cell/table-cell";
import { TableHeader } from "../table-header/table-header";
import { Table } from "../table";

@Component({
    tag: "uic-table-column-icon",
    styleUrl: "table-column-icon.scss",
    shadow: false,
})
export class TableColumnIcon implements Column {
    /** defines which field of the table will be displayed in the column */
    @Prop() field: string;
    /** defines the icon field name of the table column */
    @Prop() iconField: string;
    /** defines the label of the table column */
    @Prop() label: string;
    /** defines if the column should be a group */
    @Prop() group: boolean = false;
    /** defines if the column should be sortable */
    @Prop() sortable: boolean = false;
    /** defines the sort field name, if set, instead of using the column field */
    @Prop() sortField?: string;
    /** wrap the content of this column if required, requires to set a max-width on table (e.g. using `full-width` or css prop `--uic-table-width`) or column */
    @Prop() multiline: boolean = false;

    /** make the render function public */
    @Method()
    async getColumnMethods() {
        return {
            renderCell: this.renderCell.bind(this),
            renderHeader: this.renderHeader.bind(this),
            getSortString: this.getSortString.bind(this),
        };
    }

    private getSortString(row: any) {
        const sortField = this.sortField || this.field;
        if (sortField === "" || !row[sortField]) return "";
        return row[sortField] + "";
    }

    private renderHeader({ initialSortingCriterion: sortCriterion }: Table) {
        const sortData =
            sortCriterion?.sortProperty === this.sortField ||
            sortCriterion?.sortProperty === this.field
                ? sortCriterion
                : undefined;
        return (
            <TableHeader
                label={this.label}
                sortable={this.sortable}
                sortField={this.sortField || this.field}
                group={this.group}
                testId={this.field}
                initialSortDirection={sortData?.direction ?? ""}
            />
        );
    }

    private renderCell(row: any) {
        const { field, iconField, group, multiline } = this;
        const empty = iconField === "" || (!row[iconField] && !row[field]);
        return (
            <TableCell
                group={group}
                empty={empty}
                multiline={multiline}
                testId={field}
            >
                <uic-icon
                    name={row[iconField] ? row[iconField] : "#"}
                    class={{
                        "uic-table-column-icon__icon": true,
                    }}
                />
                <span>{!empty && row[field]}</span>
            </TableCell>
        );
    }
}
